import { cn } from "@/shared/lib/utils";

/**
 * Inline marker for a field that has no value in the patient's real records.
 * Used across the clinical-history / care-treatment / diagnostics pages wherever
 * a backend field is genuinely empty for this patient (as opposed to still
 * loading — use a <Skeleton/> for that).
 */
export function NotAvailable({
  label = "Not available",
  className,
}: {
  label?: string;
  className?: string;
}) {
  return (
    <span className={cn("italic text-[#9CA3AF]", className)}>{label}</span>
  );
}

/**
 * Renders `value` when it is a non-empty string, otherwise a <NotAvailable/>
 * marker. Keeps the "real data or an honest gap" branching out of every view.
 */
export function FieldValue({
  value,
  label,
  className,
}: {
  value: string | null | undefined;
  label?: string;
  className?: string;
}) {
  if (value && value.trim() !== "") return <>{value}</>;
  return <NotAvailable label={label} className={className} />;
}
